module.exports = __webpack_public_path__ + "static/media/docs.23325168.svg";